<template>
  <section class="mb-6">
    <table class="table-project-details hidden md:table">
      <tbody>
        <template v-if="projectData.level">
          <tr>
            <th>Level</th>
            <td><div v-html="projectData.level" /></td>
          </tr>
        </template>

        <template v-if="projectData.budget">
          <tr>
            <th style="vertical-align: top">
              Proposed Budget
            </th>
            <td>
              {{ stringFormatter.formatCurrency(projectData.budget) }}
            </td>
          </tr>
        </template>

        <template v-if="projectData.stakeholders">
          <tr>
            <th>Stakeholders / Social Partners</th>
            <td><div v-html="projectData.stakeholders" /></td>
          </tr>
        </template>

        <template v-if="projectData.owners">
          <tr>
            <th>Project Owners / Implementing Entity</th>
            <td><div v-html="projectData.owners" /></td>
          </tr>
        </template>

        <template v-if="projectData.startDate">
          <tr>
            <th>Estimated Start Date</th>
            <td><div v-html="dateFormatter.formatShortDate(projectData.startDate)" /></td>
          </tr>
        </template>

        <template v-if="projectData.endDate">
          <tr>
            <th>Estimated End Date</th>
            <td><div v-html="dateFormatter.formatShortDate(projectData.endDate)" /></td>
          </tr>
        </template>

        <template v-if="projectData.beneficiarySize">
          <tr>
            <th>Beneficiary Size</th>
            <td>
              {{ stringFormatter.formatNumbers(projectData.beneficiarySize) }}
            </td>
          </tr>
        </template>

        <template v-if="projectData.projectSector">
          <tr>
            <th>Project sector / industry</th>
            <td><div v-html="projectData.projectSector" /></td>
          </tr>
        </template>
      </tbody>
    </table>

    <div class="project-details-mobile border rounded md:hidden">
      <template v-if="projectData.level">
        <div class="p-2 border-b">
          <h4 class="text-gray-900 mb-1">
            Level
          </h4>

          <div
            class="text-sm"
            v-html="projectData.level"
          />
        </div>
      </template>

      <template v-if="projectData.budget">
        <div class="p-2 border-b">
          <h4 class="text-gray-900 mb-1">
            Proposed Budget
          </h4>
          <span v-html="projectData.budget" />
        </div>
      </template>

      <template v-if="projectData.stakeholders">
        <div class="p-2 border-b">
          <h4 class="text-gray-900 mb-1">
            Stakeholders / Partners
          </h4>
          <div v-html="projectData.stakeholders" />
        </div>
      </template>

      <template v-if="projectData.owners">
        <div class="p-2">
          <h4 class="text-gray-900 mb-1">
            Project Owners
          </h4>
          <div v-html="projectData.owners" />
        </div>
      </template>
    </div>
  </section>
</template>

<script setup>
import { useDateFormatter, useStringFormatter } from '@/composables/index.js';

const dateFormatter = useDateFormatter();
const stringFormatter = useStringFormatter();

defineProps({
  projectData: {
    type: Object,
    default: () => ({}),
  },
});

</script>

<style scoped>

</style>
